import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import React from "react";

import { card } from "../../card.style";

export type CardBodyComponentProps = {};

export type CardBodyProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, CardBodyComponentProps, "div">;

const CardBody = <T extends React.ElementType = "div">({
    ref,
    className,
    tag,
    ...attributes
}: CardBodyProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const { body } = card({});

    return (
        <Tag
            {...attributes}
            className={body({ className })}
            ref={ref}
        />
    );
};

export { CardBody };
